module.exports = __webpack_public_path__ + "img/crossmobile.ae38c895.svg";